import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import InstallWebPackageManagers from "./install-web-package-managers.mdx";
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    {/* Keep in sync with https://github.com/PostHog/posthog-js/tree/main/playground/nuxtjs */}

    <ol>
      <li parentName="ol">{`Install `}<inlineCode parentName="li">{`posthog-js`}</inlineCode>{` using your package manager:`}</li>
    </ol>
    <InstallWebPackageManagers mdxType="InstallWebPackageManagers" />
    <ol {...{
      "start": 2
    }}>
      <li parentName="ol">{`Add your PostHog API key and host to your `}<inlineCode parentName="li">{`nuxt.config.js`}</inlineCode>{` file. You can find these in `}<a parentName="li" {...{
          "href": "https://us.posthog.com/settings/project"
        }}>{`your project settings`}</a>{`.`}</li>
    </ol>
    <pre><code parentName="pre" {...{
        "className": "language-js",
        "metastring": "file=nuxt.config.js",
        "file": "nuxt.config.js"
      }}>{`export default defineNuxtConfig({
  runtimeConfig: {
    public: {
      posthogPublicKey: process.env.NUXT_PUBLIC_POSTHOG_KEY || '<ph_project_api_key>',
      posthogHost: process.env.NUXT_PUBLIC_POSTHOG_HOST || '<ph_client_api_host>',
      posthogDefaults: '<ph_posthog_js_defaults>',
    },
  }
})
`}</code></pre>
    <ol {...{
      "start": 3
    }}>
      <li parentName="ol">{`Create a new plugin by creating a new file `}<inlineCode parentName="li">{`posthog.client.js`}</inlineCode>{` in your `}<a parentName="li" {...{
          "href": "https://nuxt.com/docs/guide/directory-structure/plugins"
        }}>{`plugins directory`}</a>{`.`}</li>
    </ol>
    <pre><code parentName="pre" {...{
        "className": "language-js",
        "metastring": "file=plugins/posthog.client.js",
        "file": "plugins/posthog.client.js"
      }}>{`import { defineNuxtPlugin, useRuntimeConfig } from '#imports'

import posthog from 'posthog-js'

export default defineNuxtPlugin(() => {
  const runtimeConfig = useRuntimeConfig()
  const posthogClient = posthog.init(runtimeConfig.public.posthogPublicKey, {
    api_host: runtimeConfig.public.posthogHost,
    defaults: runtimeConfig.public.posthogDefaults,
    loaded: (posthog) => {
      if (import.meta.env.MODE === 'development') posthog.debug()
    },
  })

  return {
    provide: {
      posthog: () => posthogClient,
    },
  }
})
`}</code></pre>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      